export default "__VITE_ASSET__Du76vD6o__"